
import moment from 'moment'

const getters = {
  getNumberOfTourists: (state) => {
    const tourists = state.rooms

    return {
      total: tourists.reduce((sum, room) => (sum + room.adults + room.children), 0),
      adults: tourists.reduce((sum, room) => (sum + room.adults), 0),
      children: tourists.reduce((sum, room) => (sum + room.children), 0),
      numbrOfChildren: tourists.reduce((sum, room) => (
        sum + room.ages.filter(age => age >= 2 && age < 12).length
      ), 0),
      numberOfInfants: tourists.reduce((sum, room) => (
        sum + room.ages.filter(age => age < 2).length
      ), 0),
    }
  },
  getTouristsForm: state => state.touristsForm,
  getTouristsForSearch: state => state.touristsForm.map((tourist, index) => ({
    id: null,
    name: tourist.name,
    surname: tourist.surname,
    middleName: tourist.middleName,
    gender: tourist.gender,
    birthday: tourist.birthday,
    documentNumber: tourist.documentNumber,
    roomId: tourist.roomId,
    phone: tourist.phone ? tourist.phone.split(' ').join('') : tourist.phone,
    email: tourist.email,
    documentType: tourist.documentType,
    expirationDate: tourist.expirationDate,
    citizen: tourist.citizen,
    variantId: state.visa.visas.selected[index],
    visaId: state.visa.visas.ids[index]
  })),
  getDocumentsParams: state => (touristIndex) => {
    const currentTourist = state.touristsForm[touristIndex]
    const ageTourist = moment().diff(moment(currentTourist.birthday, 'DD.MM.YYYY'), 'years')
    let passengerType = 'ADULT'

    if (ageTourist < 2) {
      passengerType = 'INFANT'
    } else if (ageTourist >= 2 && ageTourist < 12) {
      passengerType = 'CHILD'
    }

    return {
      passengerType,
      citizen: currentTourist.citizen,
      arrivalLocationId: 74,
      departureLocationId: 91
    }
  }
}

export default getters